import styled from "styled-components";

export const StyledPortionInput = styled.input<{ $width?: number }>`
  width: ${({ $width }) => $width ?? 90}px;
  padding: 0px 4px;
  text-align: center;
  font-size: 16px;
  height: 44px;

  border: none;
  border-bottom: 1px solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
  background: var(--Schemes-Surface-Container-Lowest, #fff);
  color: var(--Schemes-Primary, #0da3ba);

  &,
  &:focus,
  &:visited,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: var(--color-navy);
    opacity: 0.36;
    font-family: proxima-nova;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: var(--color-navy);
    opacity: 0.36;
    font-family: proxima-nova;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`
